import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.USER };
const path = "/user"


export const getProductDetails = async (value) => {
    return await axiosInstance(options).get(`${path}/products/product-details?o_id=${value}`);
}

export const getTrendingProducts = async () => {
    return await axiosInstance(options).get(`${path}/products/trending-products`);
}

export const favouriteUnfavouriteProduct = async (productId) => {
    return await axiosInstance(options).put(`${path}/products/favourite-unfavourite-product?product_id=${productId}`);
}

export const getFavouriteProducts = async () => {
    return await axiosInstance(options).get(`${path}/products/favourite-products`);
}













